export default __webpack_public_path__ + "static/media/managing-platform-bms.a7e11a91.svg";